import React from 'react';
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import './InputSelectField.scss'

const InputSelectField = props => {
  const { inputId, value, options, onChange, editMode, disabledMode, error, helperText } = props;

  const selectedOption = options.filter(option => option?.value === value);
  const selectedOptionLabel = selectedOption.length ? selectedOption[0].label : '';

  const nullSafeValue = (value === null) ? '' : value;

  const handleChange = value => {
    const nullOption = options.filter(option => option.value === null);
    if (
      value === '' ||
      (nullOption.length && value === nullOption[0].label)
    ) {
      value = null;
    }

    onChange(value);
  }

  return (
    <div className="parkchirp--input-select-field">
      {editMode ? (
        <TextField
          id={inputId}
          disabled={disabledMode}
          onChange={(event) => handleChange(event.target.value)}
          select
          value={nullSafeValue}
          variant="outlined"
          error={error}
          helperText={helperText}
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              disabled={option.disabled}
            >
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      ) : (
        <span>{selectedOptionLabel}</span>
      )}
    </div>
  );
};

export default InputSelectField;
